exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-input.is-disabled[data-v-0ba0ec14] .el-input__inner{background-color:#f7f7f7;border-color:#e1e4ea}.el-input.isView[data-v-0ba0ec14] .el-input__inner{background-color:#f7f7f7}\n", ""]);

// exports
